import { date } from 'quasar'

function formatLogTime (time) {
  return date.formatDate(time, 'HH:mm:ss.SSS')
}

export default class UpdatesManager {
  constructor (config) {
    this.autoUpdate = !!config.autoUpdate
    this.autoUpdateTimeout = config.autoUpdateTimeout || 60000 // 1 мин
    this.updateFn = config.updateFn
    this.skipUpdateFn = config.skipUpdateFn
    this.autoUpdateFn = config.autoUpdateFn

    this.lastUpdateStartTime = null
    this.lastUpdateEndTime = null
    this.updateHandler = null
    this.updateActive = false // Наличие не завершившегося обновления. = this.lastUpdateStartTime && (!this.lastUpdateEndTime || this.lastUpdateEndTime < this.lastUpdateStartTime)
    this.updatesStopped = false
    this.updatesStopConditions = new Set()
    this.immediateUpdateRequired = false

    this.componentName = config.componentName

    this.documentVisibilityListener = null
    this.documentVisibilityTimer = null
    this.documentVisibilityCheckInterval = 2000
    if (config.listenDocumentVisibility) {
      // отслеживать изменение активной вкладки
      this.documentVisibilityListener = e => {
        switch (document.visibilityState) {
          case 'hidden':
            clearTimeout(this.documentVisibilityTimer)
            this.log('document hidden')
            this.stopUpdates('documentVisibility')
            break
          case 'visible':
            // Задержка установки активного состояния, чтобы исключить случай быстрого пролистывания страниц браузера
            this.log('document visible')
            this.documentVisibilityTimer = setTimeout(() => {
              this.restoreUpdates('documentVisibility')
            }, this.documentVisibilityCheckInterval)
            break
        }
      }
      document.addEventListener('visibilitychange', this.documentVisibilityListener)
    }
  }

  // @private
  onPlannedUpdate () {
    if (this.autoUpdateFn) {
      return this.autoUpdateFn() // -> this.onUpdate()
    }
    return this.onUpdate()
  }

  onUpdate () {
    if (this.updateActive || this.updatesStopped) {
      // Обновление запустится сразу после уже выполняющегося обновления или после запуска обновлений
      this.log('update set to queue')
      this.immediateUpdateRequired = true
      return
    }
    this.onUpdateStart()
    return this.updateFn(...arguments)
      .finally(() => {
        this.onUpdateEnd()
      })
  }

  onUpdateStart () {
    this.clearPlannedUpdate()
    this.immediateUpdateRequired = false

    this.updateActive = true
    this.lastUpdateStartTime = new Date()
    this.log('update start')
  }

  onUpdateEnd () {
    this.updateActive = false
    this.lastUpdateEndTime = new Date()
    this.log('update end')

    if (!this.updatesStopped) {
      if (this.immediateUpdateRequired) {
        this.log('update repeat')
        this.onUpdate()
      } else if (this.autoUpdate) {
        this.setPlannedUpdate()
      }
    }
  }

  setPlannedUpdate (timeout) {
    this.clearPlannedUpdate()

    if (timeout == null) {
      timeout = this.autoUpdateTimeout
    }
    this.updateHandler = setTimeout(() => {
      if (this.isPlannedUpdateAvailable()) {
        this.log('planned update')
        this.onPlannedUpdate()
      } else {
        this.log('planned update - skipped')
        this.setPlannedUpdate()
      }
    }, timeout)
    this.log('next planned update -> ' + (formatLogTime(new Date().getTime() + timeout)))
  }

  isPlannedUpdateAvailable () {
    // TODO !this.updatesStopped ?
    if (this.skipUpdateFn) {
      return !this.skipUpdateFn()
    }
    return true
  }

  clearPlannedUpdate () {
    clearTimeout(this.updateHandler)
  }

  stopUpdates (condition) {
    this.clearPlannedUpdate()
    this.updatesStopped = true
    if (condition) {
      this.updatesStopConditions.add(condition)
    }
    this.log('updates stop: "' + (condition || '--') + '"')
  }

  restoreUpdates (condition, immediate) {
    if (condition) {
      this.updatesStopConditions.delete(condition)
    }
    if (immediate) {
      this.immediateUpdateRequired = true
    }
    if (this.updatesStopConditions.size > 0) {
      this.log('updates NOT restored: "' + (condition || '--') + '"')
      return
    }
    this.log('updates restored: "' + (condition || '--') + '"')
    this.updatesStopped = false

    // Если есть активное обновление, то автообновление запустится само после его завершения
    if (!this.updateActive) {
      if (this.immediateUpdateRequired) {
        this.onUpdate()
      } else if (this.autoUpdate) {
        let timeout = 0
        const currentTime = new Date()
        if (this.lastUpdateEndTime) {
          const nextUpdateStartTime = this.lastUpdateEndTime.getTime() + this.autoUpdateTimeout
          const nextUpdateTimeout = nextUpdateStartTime - currentTime.getTime()
          if (nextUpdateTimeout > 0) {
            timeout = nextUpdateTimeout
          }
        }

        if (!timeout) {
          this.setPlannedUpdate(0)
        } else {
          // С прошлого обновления прошло мало времени
          this.setPlannedUpdate(timeout)
        }
      }
    }
  }

  isAutoUpdateExpired (currentTime = new Date()) {
    return !this.lastUpdateEndTime || currentTime.getTime() > this.lastUpdateEndTime.getTime() + this.autoUpdateTimeout
  }

  destroy () {
    this.stopUpdates('destroy')
    document.removeEventListener('visibilitychange', this.documentVisibilityListener)
  }

  log (text) {
    // const time = formatLogTime(new Date())
    // console.log(`${time} : ${this.componentName} ${text}`)
  }
}
